import { render, staticRenderFns } from "./TherapistDashReports.vue?vue&type=template&id=d4eb8282"
import script from "./TherapistDashReports.vue?vue&type=script&lang=js"
export * from "./TherapistDashReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports